import { componentLabel } from '../utils/editor';
import calendarLines from './calendar-lines.svg';

export default (editor, options) => {
  editor.BlockManager.add(options.componentType, {
    label: componentLabel('AddEvent calendar', calendarLines),
    category: options.category,
    content: { type: options.componentType },
  });
}
